import { ButtonLink } from '@/components/ui/Button'
import { Container } from '@/components/ui/Container'
import { BrandMark } from '@/components/visuals'
import { ECLIPSE_DATE_ISO } from '@/config/eclipse'
import { ROUTES } from '@/config/site'
import { useI18n } from '@/i18n'
import { formatDate } from '@/lib/datetime'

import { CalendarView } from './CalendarView'
import { CountdownGrid } from './CountdownGrid'
import { PhaseStatus } from './PhaseStatus'

export function Hero() {
  const { t, locale } = useI18n()

  return (
    <section className="relative overflow-hidden pb-16 pt-10 sm:pb-20 sm:pt-16 lg:pb-28 lg:pt-20">
      {/* Corona wash behind the hero */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-0 -z-10 h-[min(80vw,34rem)] w-[min(80vw,34rem)] -translate-x-1/2 -translate-y-1/3 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.16)_0%,transparent_68%)] blur-2xl"
      />

      <Container className="text-center">
        <BrandMark
          size="lg"
          priority
          className="mx-auto w-28 animate-[var(--animate-rise)] sm:w-40"
        />

        <p className="eyebrow mt-8 animate-[var(--animate-rise)]">{t.hero.eyebrow}</p>

        {/* The brand lockup: two co-equal titles joined by an ampersand.
            Left readable by screen readers — "… 2027 & Ekspedisi 7 Cahaya"
            is exactly how the name is spoken. */}
        <h1 className="mt-4 animate-[var(--animate-rise)] font-serif text-[clamp(2rem,9vw,4.5rem)] leading-[1.05]">
          <span className="block text-parchment">{t.hero.title}</span>
          <span className="my-1 block text-[0.45em] leading-none text-gold/60 sm:my-2">&amp;</span>
          <span className="gold-text block italic">{t.hero.theme}</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl animate-[var(--animate-rise)] text-base text-muted sm:text-lg">
          {t.hero.lead}
        </p>

        <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <ButtonLink to={ROUTES.cahaya}>{t.hero.ctaPrimary}</ButtonLink>
          <ButtonLink to={ROUTES.join} variant="ghost">
            {t.hero.ctaSecondary}
          </ButtonLink>
        </div>

        <div className="mt-14 sm:mt-20">
          <p className="mb-5 text-[0.6875rem] uppercase tracking-[0.24em] text-faint">
            {formatDate(ECLIPSE_DATE_ISO, locale)} · {t.countdown.subheading}
          </p>
          <CountdownGrid />
          <CalendarView className="mt-8" />
          <PhaseStatus className="mt-8" />
        </div>
      </Container>
    </section>
  )
}
